// import XHR from 'bpm-xhr';


class ImageController {

	constructor() {
		this.cache = {};
		this.loading = {};
		this.queue = {};

		this.setCacheProxy();
	}

	setCacheProxy() {
		this.cache = new Proxy({}, {
			get: (obj, prop) => obj[prop],
			set: (obj, prop, value) => {
				obj[prop] = value;
				if (this.queue[prop]) {
					for (const cb of this.queue[prop]) cb(this.cache[prop].cloneNode());
					delete this.queue[prop];
				}
				return true;
			}
		});
	}

	loadBlob(src) {
		this.loading[src] = true;
		return new Promise((resolve) => {
			// new XHR('blob')
			// 	// .onProgress((e) => {
			// 	// 	console.log(e.loaded / e.total);
			// 	// })
			// 	.get(src)
			// 	.then(xhr => {
			// 		const img = document.createElement('img');
			// 		img.onload = () => {
			// 			// window.URL.revokeObjectURL(img.src);
			// 			delete this.loading[src];
			// 			this.cache[src] = img;
			// 			resolve();
			// 		};
			// 		img.src = window.URL.createObjectURL(xhr.response);
			// 	});
			// const newSrc = src.replace('.jpg', '');

			const img = document.createElement('img');
			img.onload = () => {
				this.cache[src] = img;
				delete this.loading[src];
				resolve();
			};
			img.src = src;
			// img.srcset = `
			// 	${newSrc}-2x.jpg 2x,
			// 	${newSrc}-1.5x.jpg 1.5x,
			// 	${newSrc}-1x.jpg 1x,
			// 	${newSrc}-0.5x.jpg 0.5x
			// `;
		});
	}

	addToQueue(src, cb) {
		if (!this.queue[src]) this.queue[src] = [];
		this.queue[src].push(cb);
	}

	append(img, newImg) {
		img.parentNode.appendChild(newImg);
		// const parent = img.parentNode;
		// parent.insertBefore(newImg, parent.childNodes[0]);
	}

	swap(img) {
		return new Promise((resolve) => {
			const { src } = img.dataset;
			const cb = () => {
				// const parent = img.parentNode;
				// const width = parent.clientWidth;
				// const height = parent.clientHeight;
				// const canvas = document.createElement('canvas');
				// canvas.width = width;
				// canvas.height = height;
				// const context = canvas.getContext('2d');
				// context.drawImage(this.cache[src], 0, 0, width, height);
				// this.append(img, canvas);
				// resolve(canvas);
				const newImg = this.cache[src].cloneNode();
				this.append(img, newImg);
				img.classList.add('is-swapped');
				resolve(newImg);
			};
			if (this.cache[src]) {
				cb();
			} else if (this.loading[src]) {
				this.addToQueue(src, () => cb());
			} else {
				this.loadBlob(src).then(() => cb());
			}
		});
	}

}

export default new ImageController();
